import React, { useEffect, useState } from 'react';

import { Modal } from '@getethos/ethos-design-system-v2';
import { Form } from 'ethos-design-system';
import { v4 as uuidv4 } from 'uuid';

import {
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import styles from './styles.module.scss';
import { NoraButton } from './v2';
import Spacer from './v2/Spacer';

export const NoraDecisionModal = ({
  isOpen,
  onDismiss,
  title,
  message,
  label,
  reasonOptions,
  onCancel,
  onSubmit,
  isLoading = false,
}: {
  isOpen: boolean;
  onDismiss?: any;
  title: string;
  message: string;
  label: string;
  reasonOptions: any;
  onCancel?: any;
  onSubmit: any;
  isLoading?: boolean;
}) => {
  const initialReasonValue: string = '';
  const [lastReason, setLastReason] = useState(initialReasonValue);

  // Reset selected reason when modal closes
  useEffect(() => {
    if (!isOpen) {
      setLastReason(initialReasonValue);
    }
  }, [isOpen]);

  return (
    <Modal title={title} open={isOpen} onClose={onDismiss}>
      <div className={styles.Modal}>
        <p className={styles.ModalPara}>{message}</p>
        <label className={styles.ModalLabel}>{label}</label>
        <div className={styles.ModalFormContainer}>
          {isLoading ? (
            <div className={styles.ModalLoaderWrapper}>
              <CircularProgress size={24} />
              <span>Loading reasons...</span>
            </div>
          ) : (
            <Form
              config={{
                formName: 'Waive reason form',
                autocompleteOff: true,
                formId: uuidv4(),
                fields: {
                  reason: {
                    component: (_: any, opts: any) => {
                      return (
                        <RadioGroup
                          value={lastReason}
                          onChange={e => setLastReason(e.target.value)}
                          name="reason-options"
                        >
                          {opts.map((option: any) => (
                            <FormControlLabel
                              key={option.value}
                              value={option.value}
                              control={<Radio />}
                              label={option.label}
                            />
                          ))}
                        </RadioGroup>
                      );
                    },
                    name: 'reasons-radios',
                    tid: 'reasons-radios-tid',
                    labelCopy: '',
                    options: reasonOptions,
                  },
                },
                onSubmit: async () => {
                  onSubmit(lastReason);
                },
              }}
            >
              {(api: any) => {
                const { field } = api;
                return (
                  <div>
                    <Spacer height={16} />
                    {field('reason')}
                    <Spacer height={16} />
                    <div className={styles.ModalButtonsWrapper}>
                      <NoraButton
                        variant="secondary"
                        type="button"
                        onClick={onCancel}
                      >
                        Cancel
                      </NoraButton>
                      <NoraButton
                        variant="primary"
                        className={styles.ModalSubmitButton}
                        type="button"
                        onClick={() => onSubmit(lastReason)}
                        data-tid="button-waive-submit"
                        disabled={!lastReason}
                      >
                        Waive
                      </NoraButton>
                    </div>
                  </div>
                );
              }}
            </Form>
          )}
        </div>
      </div>
    </Modal>
  );
};
